import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { AcceleratorWithAvailableSeats } from '@interfaces';
import { AdmissionsAreaService } from '../admissions-area.service';

interface SeatCount {
	accName: string;
	offered: number;
	accepted: number;
}

@Component({
	selector: 'acc-offered-seat-counts-part',
	standalone: true,
	templateUrl: './acc-offered-seat-counts.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./acc-offered-seat-counts.part.scss'],
})
export class AccOfferedSeatCountsPart {

	private areaService = inject(AdmissionsAreaService);

	public seatCounts = computed(() => {
		const accelerators = this.areaService.admissionsData()?.accelerators;
		if (!accelerators) return;

		// Map accelerators to seat counts
		const counts: SeatCount[] = accelerators.map((acc: AcceleratorWithAvailableSeats) => ({
			accName: acc.name,
			offered: acc.seatsOffered,
			accepted: acc.seatsAccepted
		}));

		// Calculate totals
		const total: SeatCount = {
			accName: 'Total',
			offered: counts.reduce((sum, count) => sum + count.offered, 0),
			accepted: counts.reduce((sum, count) => sum + count.accepted, 0)
		};

		return [...counts, total];
	});
}
